module.exports = __webpack_public_path__ + "img/arrow-down.28a6ecd1.svg";